export default __webpack_public_path__ + "static/media/budgetTrackingEnabled.d1cbb073.png";